import { makeStyles } from 'tss-react/mui';

import { IconWrapper } from 'src/legacy/components/AgGrid';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';

import { NotificationTableRowData } from './InboxContent';

interface NotificationTableNameRendererProps {
  data: NotificationTableRowData;
}

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    display: 'flex',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));

export const NotificationTableNameRenderer = (
  props: NotificationTableNameRendererProps,
) => {
  const {
    data: { name, fileExtension },
  } = props;
  const { classes } = useStyles();
  return (
    <div className={classes.wrapper}>
      {fileExtension && (
        <div className={classes.icon}>
          <IconWrapper extension={fileExtension} />
        </div>
      )}
      <BaseTypography fontType="13Regular">{name}</BaseTypography>
    </div>
  );
};
